<template>
  <div v-if="userInfo.data.isApiEnabled" class="col7-of-12">
    <TextField
      ref="apiKey"
      label="To connect securely with PartnerPage, you need an API Key with permission to access resources such as leads."
      type="text"
      name="apiKey"
      elId="apiKey"
      style="border: 0; background: transparent; padding-left: 0; padding-right: 0;"
      readonly="readonly"
      :value="userInfo.api.token"
      :link="userInfo.api.token ? 'Copy key' : ''"
      :link-action="copyText"
    />

    <Button
      v-if="!userInfo.api.token"
      class="no-transform"
      v-on:button-click="generateApiKey"
      >Generate API Key</Button
    >
    <Button
      v-else-if="userInfo.api.token"
      class="no-transform"
      b-type="secondary"
      v-on:button-click="openDisableModal"
      >Disable API Key</Button
    >
    <Modal
      v-if="modalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="modalOpen"
      title="Disable API Key?"
      description="Disabling an API key immediately renders it unusable. You will need to generate a new key if you want access again, are you sure you want to disable this?"
      @close-modal="modalOpen = false"
      @primary-click="disable"
      @secondary-click="modalOpen = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Button from '@/components/DesignSystem/Button';
import TextField from '@/components/DesignSystem/Inputs/TextField';
import Modal from '@/components/DesignSystem/Modal';

export default {
  components: { Button, TextField, Modal },
  data() {
    return {
      modalOpen: false,
    };
  },
  methods: {
    ...mapActions({
      generateApiKey: 'userAccount/generateApiKey',
      disableApiKey: 'userAccount/disableApiKey',
      fetchApiKey: 'userAccount/fetchApiKey',
    }),
    disable() {
      this.disableApiKey();
      this.modalOpen = false;
    },
    openDisableModal() {
      this.modalOpen = true;
    },
    copyText() {
      let textToCopy = this.$refs.apiKey.$el.querySelector('input');
      textToCopy.select();
      document.execCommand('copy');
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'userAccount/userInfo',
    }),
  },
  created() {
    this.fetchApiKey();
  },
};
</script>
